/* src/views/AppointmentsView.js */
/* src/views/AppointmentsView.js */
import { ref, computed, onMounted, watch } from 'vue'
import { Plus, Edit, Trash2, X, Search, Calendar, RefreshCw } from 'lucide-vue-next'
import { AppointmentService } from '@/services/AppointmentService'
import { OperatorService } from '@/services/OperatorService' // Assicurati di avere questo import
import api from '@/services/api'
import Swal from 'sweetalert2'

export default {
  name: 'AppointmentsView',
  components: {
    Plus, Edit, Trash2, X, Search, Calendar, RefreshCw
  },

  setup() {
    const appointments = ref([])
    const currentAppointmentId = ref(null)
    const currentBookingItems = ref([])
    const isDrawerOpen = ref(false)
    const isEditing = ref(false)
    const operators = ref([])
    const searchQuery = ref('')
    const selectedOperator = ref('')

    const form = ref({
      cliente: '',
      data: '',
      importoPagato: 0,
      importoTotale: 0,
      note: '',
      orafine: '',
      orainizio: '',
      stato: 'Da pagare',
      status: 'In Attesa',
      items: [],
    })

    const fetchAppointments = async () => {

        try {

            const params = (selectedOperator.value && selectedOperator.value !== '')
              ? { operator: selectedOperator.value }
              : {}

            const data = await AppointmentService.getAll(params) 

            appointments.value = data 
            console.log("Appuntamenti caricati:", appointments.value)
        } 
        catch (error) {

            console.error("Errore caricamento:", error)
        }
    }

    const fetchOperators = async () => {
      try {
        operators.value = await OperatorService.getAll()
      } catch (err) {
        console.error("Errore caricamento operatori:", err)
      }
    }

    // 2. Watcher corretto: viene eseguito solo DOPO che le funzioni sono definite
    watch(selectedOperator, () => {
      fetchAppointments()
    })

    onMounted(() => {
      fetchAppointments()
      fetchOperators()
    })

    const filteredAppointments = computed(() => {
      
      if (!searchQuery.value) {

        return appointments.value
      }

      const query = searchQuery.value.toLowerCase()

      console.debug("*** DEBUG filteredAppointments", appointments.value.filter(a =>
        (a.cliente && a.cliente.toLowerCase().includes(query)) ||
        (a.note && a.note.toLowerCase().includes(query))
      ))

      return appointments.value.filter(a =>
        (a.cliente && a.cliente.toLowerCase().includes(query)) ||
        (a.note && a.note.toLowerCase().includes(query))
      )
    })

    const resetForm = () => {

      form.value = {
        cliente: '',
        data: '',
        orainizio: '',
        orafine: '',
        status: 'In Attesa',
        importoTotale: 0,
        importoPagato: 0,
        stato: 'Da pagare',
        note: ''
      }
      isEditing.value = false
      currentAppointmentId.value = null
    }

    const openCreateDrawer = () => {

      resetForm()
      isDrawerOpen.value = true
    }

    const getStatusClass = (status) => {

      switch (status) {
        case 'to_pay': return 'badge-stato stato-da-pagare'
        case 'partial': return 'badge-stato stato-pagamento-parziale'
        case 'paid': return 'badge-stato stato-saldato'
        case 'refunded': return 'badge-stato stato-rimborsato'
        default: return 'badge-stato'
      }
    }

    const getOperatoriCoinvolti = (items) => {
    
      const arrayItems = items.value || items
      
      if (!arrayItems || arrayItems.length === 0) return "Nessun servizio/operatore"
    
      return arrayItems
        .map(i => `${i.service_name} (${i.operator_name || 'Non assegnato'})`)
        .join(', ')
    }

    const openEditDrawer = async (appt) => {
    
      try {
    
        const response = await api.get(`/booking/list/${appt.id}/`)
        const data = response.data

        const parseDateParts = (dateStr) => {

          if (!dateStr || typeof dateStr !== 'string') return ['', '']

          const parts = dateStr.replace('T', ' ').split(' ')
          const d = parts[0] || ''
          const t = parts[1] ? parts[1].substring(0, 5) : ''
          return [d, t]
        }
    
        const [dateStart, timeStart] = parseDateParts(data.date_start)
        const [_, timeEnd] = parseDateParts(data.date_end)
    
        currentAppointmentId.value = data.id
        form.value = {
          cliente: data.customer_name || '',
          data: dateStart,
          importoPagato: data.paid_amount || 0,
          importoTotale: data.total_amount || 0,
          items: data.items || [],
          note: data.notes || '',
          orafine: timeEnd,
          orainizio: timeStart,
          status: data.status,
          stato: data.payment_status,
        }
    
        currentBookingItems.value = data.items || []
        isDrawerOpen.value = true
        isEditing.value = true
      } 

      catch (err) {

        console.error("Errore apertura drawer:", err)
        Swal.fire('Errore', 'Impossibile caricare i dati dell\'appuntamento', 'error')
      }
    };

    const closeDrawer = () => {

      isDrawerOpen.value = false
      setTimeout(resetForm, 300)
    }

    const saveAppointment = async () => {
      try {
        if (isEditing.value && currentAppointmentId.value) {
          await AppointmentService.update(currentAppointmentId.value, form.value)
        } else {
          await AppointmentService.create(form.value)
        }
        await fetchAppointments()
        closeDrawer()
      } catch (error) {
        Swal.fire({ title: 'Errore', text: 'Errore durante il salvataggio', icon: 'error' })
      }
    }

    const deleteAppointment = async (id) => {
      if (confirm('Eliminare questo appuntamento?')) {
        try {
          await AppointmentService.delete(id)
          await fetchAppointments()
        } catch (error) {
          Swal.fire({ title: 'Errore', text: 'Errore eliminazione', icon: 'error' })
        }
      }
    }

    const handleAdminAction = async (id, action, newDate = null) => {
      try {
        const payload = { action }
        if (newDate) payload.new_date = newDate
        await api.post(`/booking/list/${id}/admin_manage/`, payload)
        Swal.fire('Successo', 'Operazione completata!', 'success')
        await fetchAppointments()
      } catch (err) {
        Swal.fire('Errore', 'Impossibile eseguire l\'operazione.', 'error')
      }
    }

    const promptReschedule = async (appt) => {
      const { value: date } = await Swal.fire({
        title: 'Sposta appuntamento',
        input: 'datetime-local',
        inputValue: appt.data + 'T' + appt.orainizio,
        showCancelButton: true
      })
      if (date) handleAdminAction(appt.id, 'reschedule', date)
    }

    return {
      appointments,
      closeDrawer,
      currentBookingItems,
      deleteAppointment,
      filteredAppointments,
      form,
      getOperatoriCoinvolti,
      getStatusClass,
      handleAdminAction,
      isDrawerOpen,
      isEditing,
      openCreateDrawer,
      openEditDrawer,
      operators,
      promptReschedule,
      saveAppointment,
      searchQuery,
      selectedOperator,
      formatCurrency: (v) => new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(v),
      formatDate: (d) => {
        if (!d) return '-'
        const parts = d.split('-')
        return `${parts[2]}/${parts[1]}/${parts[0]}`
      }
    }
  }
}